/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S4_Li2Inputs */

const en_guide_json_schema_s4_li2 = /** @type {(inputs: Guide_Json_Schema_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Form Validation</strong>: Generate forms from schemas and validate input client-side`)
};

const ko_guide_json_schema_s4_li2 = /** @type {(inputs: Guide_Json_Schema_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>폼 유효성 검사</strong>: 스키마에서 폼을 생성하고 클라이언트 측에서 입력 검증`)
};

const ja_guide_json_schema_s4_li2 = /** @type {(inputs: Guide_Json_Schema_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>フォームバリデーション</strong>: スキーマからフォームを生成し、クライアントサイドで入力を検証`)
};

/**
* | output |
* | --- |
* | "<strong>Form Validation</strong>: Generate forms from schemas and validate input client-side" |
*
* @param {Guide_Json_Schema_S4_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s4_li2 = /** @type {((inputs?: Guide_Json_Schema_S4_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S4_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s4_li2(inputs)
	if (locale === "ko") return ko_guide_json_schema_s4_li2(inputs)
	return ja_guide_json_schema_s4_li2(inputs)
});